import * as React from 'react';
import * as styles from './Information.css';

interface IInformationProps {
  title: React.ReactNode;
  label: React.ReactNode;
  note: React.ReactNode;
  chooseApartment: React.ReactNode;
}

export function Information(props: IInformationProps) {
  const { title, label, chooseApartment, note } = props;

  return (
    <div>
      {title && <div className={styles['information__title']}>{title}</div>}
      {label && <div className={styles['information__description']}>{label}</div>}

      {chooseApartment && (
        <div>
          {chooseApartment}
          {note && <div className={styles['information__commercial']}>{note}</div>}
        </div>
      )}
    </div>
  );
}
